import { Component, HostListener, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { trigger, state, transition, animate, style } from '@angular/animations';
import { SfhSecurityService } from '@sasser/sfh-shared-security';
import { GlobalSearchComponent } from '../../search/global-search.component';

@Component({
	standalone: true,
	selector: 'topnavbar',
	imports: [CommonModule, GlobalSearchComponent],
	templateUrl: 'topnavbar.template.html',
	animations: [
		trigger('expand360Search', [
			state('hide', style(
				{
					height: '0px',
					width: '120px',
					left: '90px',
					display: 'none'
				})),
			state('show', style(
				{
					height: '60px',
					width: '300px',
					left: '0px',
					display: 'inline !important'
				})),
			transition('* => *', animate(200))
		])
	]
})

export class TopNavbarComponent {
	@ViewChild('globalSearch') globalSearch;
	public show360Search = 'hide';

	constructor(
		public sfhAuth: SfhSecurityService
	) {}

	@HostListener('mouseenter') onmouseenter() {
		this.show360Search = 'show';
		setTimeout(() => {
			this.globalSearch.setFocus();
		},
		200);
	}

	@HostListener('mouseleave') onmouseleave() {
		this.show360Search = 'hide';
		this.globalSearch.hideInput();
	}
}
